import { BaseStationTargetInfo } from '@ais-ui/websockets';
import React from 'react';
import { useSettings } from '../../Settings/SettingsProvider';
import {
  InfoTooltipFields,
  type TooltipFieldDefinition,
} from './InfoTooltipFields';

interface BaseStationInfoTooltipProps {
  baseStationInfo: BaseStationTargetInfo;
}

export const BaseStationInfoTooltip = ({
  baseStationInfo,
}: BaseStationInfoTooltipProps) => {
  const { settings } = useSettings();
  const ribbonSettings = settings['ribbonPlugin.settings'];

  const fields: TooltipFieldDefinition[] = [
    {
      key: 'country',
      label: 'Country',
      value: baseStationInfo.country,
      visible: ribbonSettings?.show_basestation_country,
    },
    {
      key: 'latitude',
      label: 'Latitude',
      value: baseStationInfo.latitude,
      visible: ribbonSettings?.show_basestation_latitude,
    },
    {
      key: 'longitude',
      label: 'Longitude',
      value: baseStationInfo.longitude,
      visible: ribbonSettings?.show_basestation_longitude,
    },
    {
      key: 'mmsi',
      label: 'MMSI',
      value: baseStationInfo.mmsi,
      visible: ribbonSettings?.show_basestation_mmsi,
    },
    {
      key: 'vdlLoad',
      label: 'VDL Load',
      value: baseStationInfo.vdlLoad,
      visible: ribbonSettings?.show_basestation_vdl_load,
    },
  ];

  return <InfoTooltipFields fields={fields} />;
};
